/**
 * Assistant/Herald message bubble: left-aligned with avatar and content area.
 */
import { HandraiseH } from "@/assets/handraise";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

export interface ChatBubbleProps {
  children: ReactNode;
  className?: string;
  /** When false, content is full width (e.g. while the assistant reply is streaming). */
  showAvatar?: boolean;
}

const ChatBubble = ({
  children,
  className,
  showAvatar = true,
}: ChatBubbleProps) => (
  <div
    className={cn(
      "flex w-full",
      showAvatar ? "items-baseline gap-2" : "",
      className,
    )}
  >
    {showAvatar ? (
      <>
        <div className="flex size-7 shrink-0 items-center justify-center">
          <HandraiseH className="size-3" />
        </div>
        <div className="flex min-w-0 flex-1 flex-col gap-3">{children}</div>
      </>
    ) : (
      <div className="flex min-w-0 w-full flex-col gap-3">{children}</div>
    )}
  </div>
);

export default ChatBubble;
